module.exports = __webpack_public_path__ + "assets/img/df32-yt.svg";